export default __webpack_public_path__ + "static/media/hotel3.a3d23d2b.jpg";